import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function Receipt({ data, mode = "normal", onClose }) {
  const receiptRef = useRef();
  if (!data) return null;

  const patient = data.walkInLabRequest?.walkInPatient;
  const breakdowns = data.paymentRecordBreakdowns || [];
  const total = breakdowns.reduce((sum, x) => sum + (x.patientDuePay || 0), 0);

  const containerStyle = {
    width: mode === "thermal" ? "280px" : "380px",
    padding: "16px",
    margin: "0 auto",
    background: "#fff",
    fontFamily: "monospace",
    border: "1px solid #ccc",
  };

  const printPDF = async () => {
    const element = receiptRef.current;
    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({ unit: "pt", format: "a4" });
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save("receipt.pdf");
  };

  const directPrint = () => {
  const printContents = receiptRef.current.innerHTML;

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";

  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;

  doc.open();
  doc.write(`
    <html>
      <head>
        <title>Receipt Print</title>
      </head>
      <body>
        <div style="font-family: monospace;">
          ${printContents}
        </div>
      </body>
    </html>
  `);
  doc.close();

  iframe.onload = () => {
    // Wait for images to load
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 500);
  };
};


  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}>
      <div style={{ background: "white", padding: "20px", borderRadius: "8px", maxHeight: "90vh", overflowY: "auto", position: "relative" }}>

        {/* Close Button */}
        <button onClick={onClose} style={{ position: "absolute", top: "10px", right: "10px", padding: "5px 8px", cursor: "pointer" }}>X</button>

        {/* Header */}
        <div style={{ marginBottom: "10px", fontFamily: "monospace" }}>
          <strong>Print Mode:</strong> {mode === "thermal" ? "Thermal 58mm" : "Normal Receipt"}
        </div>

        {/* ACTION BUTTONS */}
        <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
          <button onClick={printPDF} style={{ padding: "6px 10px" }}>Print PDF</button>
          <button onClick={directPrint} style={{ padding: "6px 10px" }}>Direct Print</button>
        </div>

        <div ref={receiptRef} style={containerStyle}>
          {/* Logo */}
          <div style={{ textAlign: "center", marginBottom: "12px" }}>
            {/* <img src="/logo.png" alt="Lab Logo" style={{ width: "70px", height: "70px", margin: "0 auto" }} /> */}
            <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>${sessionStorage.getItem("healthCareProviderName")}</h2>
            <p style={{ fontSize: "11px" }}>${sessionStorage.getItem("location")}</p>
          {/* </p> */}
            <p style={{ fontSize: "11px" }}>{sessionStorage.getItem("phone")}</p>
          </div>
          <hr />

          {/* Patient Info */}
          <div style={{ fontSize: "13px", marginBottom: "10px" }}>
            <p><strong>Patient:</strong> {patient?.firstName} {patient?.lastName}</p>
            <p><strong>Phone:</strong> {patient?.phoneNumber}</p>
            <p><strong>Category:</strong> {data.paymentCategory?.name}</p>
            <p><strong>Date:</strong> {new Date(data.createdAt).toLocaleString()}</p>
          </div>

          <hr />

          {/* Items */}
          <div style={{ fontSize: "13px" }}>
            {breakdowns.map((item) => (
              <div key={item.id} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", borderBottom: "1px dashed #ccc" }}>
                <div>
                  <p style={{ fontWeight: "bold" }}>{item.internalLabService?.name}</p>
                  {item.discount ? (
                    <p style={{ fontSize: "10px", color: "gray" }}>Discount: ₦{item.discount.toLocaleString()}</p>
                  ) : null}
                </div>
                <p>₦{item.patientDuePay.toLocaleString()}</p>
              </div>
            ))}
          </div>

          <hr />

          {/* Total */}
          <div style={{ fontSize: "14px", fontWeight: "bold", display: "flex", justifyContent: "space-between" }}>
            <span>Total</span>
            <span>₦{total.toLocaleString()}</span>
          </div>

          <div style={{ textAlign: "center", marginTop: "12px", fontSize: "11px" }}>
            <p>Cashier: {data.recordCreatedBy?.firstName}</p>
            <p>Thank you for choosing our laboratory!</p>
          </div>
        </div>
      </div>
    </div>
  );
}